import { useEffect, useState } from 'react';
import { useUIStore } from '@/core/stores/ui.store';

const MOBILE_BREAKPOINT = 768; // md en Tailwind

export function useSidebar() {
    const [isMobile, setIsMobile] = useState(
        () => window.innerWidth < MOBILE_BREAKPOINT
    );

    const sidebarOpen = useUIStore((s) => s.sidebarOpen);
    const mobileSidebarOpen = useUIStore((s) => s.mobileSidebarOpen);
    const toggleSidebar = useUIStore((s) => s.toggleSidebar);
    const toggleMobileSidebar = useUIStore((s) => s.toggleMobileSidebar);
    const closeMobileSidebar = useUIStore((s) => s.closeMobileSidebar);

    useEffect(() => {
        const mediaQuery = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);

        const handleChange = (e: MediaQueryListEvent) => {
            setIsMobile(e.matches);

            // Al pasar a desktop cerramos el sidebar mobile para evitar estado inconsistente
            if (!e.matches) closeMobileSidebar();
        };

        mediaQuery.addEventListener('change', handleChange);
        return () => mediaQuery.removeEventListener('change', handleChange);
    }, [closeMobileSidebar]);

    return {
        isOpen: isMobile ? mobileSidebarOpen : sidebarOpen,
        isMobileOpen: mobileSidebarOpen,
        isMobile,
        toggle: isMobile ? toggleMobileSidebar : toggleSidebar,
        closeMobile: closeMobileSidebar,
    };
}